import { useStore } from '../store';

export const memoryTypes = [
  {
    value: 'human',
    label: 'Human',
    description: `One person's story. Who they are, what they've lived, and what you want remembered.`,
    icon: 'user',
  },
  {
    value: 'family',
    label: 'Family',
    description: `The story that belongs to all of you. Where you came from and what holds you together.`,
    icon: 'users',
  },
  {
    value: 'wedding',
    label: 'Wedding',
    description: `The day two people chose each other. The details worth holding onto.`,
    icon: 'bells',
  },
  {
    value: 'baby',
    label: 'New baby',
    description: `The beginning of someone's story. Capture it before the early days slip away.`,
    icon: 'baby',
  },
  {
    value: 'veteran',
    label: 'Veteran',
    description: `A life of service. The stories that deserve to be told and never forgotten.`,
    icon: 'medal',
  },
  {
    value: 'pet',
    label: 'Pet',
    description: `For the ones who were family too. Their story matters just as much.`,
    icon: 'paw',
  },
  {
    value: 'event',
    label: 'Event',
    description: `A moment that brought people together. A milestone, a reunion, a night worth remembering.`,
    icon: 'calendar',
  },
  {
    value: 'other',
    label: 'Other',
    description: `If it doesn't fit a box, it still deserves a place. Tell it in your own words.`,
    icon: 'circle-question',
  },
];

export const getMemoryType = (type: string) => {
  return memoryTypes.find((memoryType) => memoryType.value === type);
};

export const memoryPlaceholders = {
  name: 'Your name',
  dedicated_to: 'Margaret Collins',
  title: 'The summer we dance in the kitchen',
  content: 'Mom used to say he asked her to dance even when there was no music. We found this photo tucked inside her old recipe box...',
};

export const setShareModalMemory = (memoryId: string) => {
  useStore.setState({ shareModal: { timelineId: null, memoryId: memoryId } });
};
